import api from '@/lib/axios';
import axios from 'axios';
import { config } from '@/config/env.config';
import { attachAxiosSentryHandlers } from '@/observability/sentry.axios';

const publicBrandingApi = axios.create({
  baseURL: config.api.baseUrl,
});

attachAxiosSentryHandlers(publicBrandingApi);

export interface BrandingResponse {
  tenantId: string;
  appName: string | null;
  slug: string;
  primaryColor: string | null;
  logoUrl: string | null;
  faviconUrl: string | null;
  customDomain: string | null;
}

export interface UpdateBrandingDto {
  appName?: string;
  customDomain?: string;
  primaryColor?: string;
}

class BrandingService {
  async resolveByDomain(domain: string): Promise<BrandingResponse> {
    // Endpoint público: usa axios diretamente sem token
    const response = await publicBrandingApi.get<BrandingResponse>('/branding', {
      params: { domain },
    });
    return response.data;
  }

  async getMyBranding(): Promise<BrandingResponse> {
    const response = await api.get<BrandingResponse>('/branding/me');
    return response.data;
  }

  async update(dto: UpdateBrandingDto): Promise<BrandingResponse> {
    const response = await api.put<BrandingResponse>('/branding', dto);
    return response.data;
  }

  async uploadLogo(file: File): Promise<BrandingResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post<BrandingResponse>('/branding/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  async uploadFavicon(file: File): Promise<BrandingResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post<BrandingResponse>('/branding/favicon', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }
}

export const brandingService = new BrandingService();
